<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      entity-name="EmployeeStatistics"
      :model="model"
      :required-date-value="$parent.dateRange"
      icon="mdi-cards"
      only-display="1"
    />
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import StaffReport from '@/model/dataLayer/api/tableAndPerson/StaffReport'

export default {
  components: {
    IkDataTable
  },
  data () {
    return {
      model: StaffReport
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
